var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 24H4C3.448 24 3 23.552 3 23V21C3 20.448 3.448 20 4 20H44C44.552 20 45 20.448 45 21V23C45 23.552 44.552 24 44 24Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32H6C5.448 32 5 31.552 5 31V13C5 12.448 5.448 12 6 12H8C8.552 12 9 12.448 9 13V31C9 31.552 8.552 32 8 32Z",
    fill: "#35C1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 38H10C9.448 38 9 37.552 9 37V7C9 6.448 9.448 6 10 6H16C16.552 6 17 6.448 17 7V37C17 37.552 16.552 38 16 38Z",
    fill: "#1B9DE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12H42C42.552 12 43 12.448 43 13V31C43 31.552 42.552 32 42 32H40C39.448 32 39 31.552 39 31V13C39 12.448 39.448 12 40 12Z",
    fill: "#35C1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6H38C38.552 6 39 6.448 39 7V37C39 37.552 38.552 38 38 38H32C31.448 38 31 37.552 31 37V7C31 6.448 31.448 6 32 6Z",
    fill: "#1B9DE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24,
    y1: 19.959,
    x2: 24,
    y2: 24.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787E85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.d660bfa21ab732114f770390744e5f41.svg";
export { ForwardRef as ReactComponent };